var path = '/components/directives/customfield/textarea.tpl.html';
var html = "<label for=\"{{name}}\" ng-if=\"field.definition.name\">{{::field.definition.name}}\n    <span ng-if=\"field.definition.required\">*</span>\n    <i class=\"fal fa-info-circle\" ng-if=\"field.definition.tooltip\">\n        <span data-tooltip=\"{{::field.definition.tooltip}}\"></span>\n    </i>\n</label>\n<p class=\"help-text\" ng-if=\"field.definition.help\">{{::field.definition.help}}</p>\n<textarea id=\"{{name}}\" ng-model=\"field.ngModel\" name=\"{{name}}\" class=\"form-control\" ng-required=\"field.definition.required\" ng-disabled=\"!!field.definition.disabled\">\n</textarea>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/directives/customfield/textarea.tpl.html
// module id = 2001
// module chunks = 1